import { createSelector } from 'reselect'
import getItemLocalStorageUtil from 'utils/local-storage/get-item'
import { PRODUCT_LOCAL_STORAGE_KEY } from 'modules/product/constants'
import getCurrentVariantUtil from 'modules/variant/utils/get-current'
import shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelectUtil from 'containers/YouVeUnlockedPercentageOffAtCheckoutBanner/selectors/should-show/utils'
import isFromGoogleProductListAdLocationUtil from 'utils/location/is-from-google-product-list-ad'
import isNewCustomerSelect from 'modules/customer/redux/selectors/is-new-customer'

const shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelect = createSelector(
  isNewCustomerSelect,
  (isNewCustomer) => shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelectUtil({
    closedAtStr: (
      getItemLocalStorageUtil(
        PRODUCT_LOCAL_STORAGE_KEY.YOU_VE_UNLOCKED_PERCENTAGE_OFF_AT_CHECKOUT_BANNER_CLOSED_AT
      )
    ),
    currentVariant: getCurrentVariantUtil(),
    isFromGoogleProductListAd: isFromGoogleProductListAdLocationUtil(),
    isNewCustomer
  })
)

export default shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelect
